// store/bootstrap.js
const actions = {
  async bootstrap({ dispatch }) {

    // 1 โหลด shop
    await dispatch('getShop')

    const shopId = localStorage.getItem('shopObjectId')

    if (!shopId) {
      throw new Error('No shop')
    }

    // 2 โหลด permission
    await dispatch('getPermission')

    // 3 โหลด shop setting
    await dispatch('getShopSetting')

  }
}

export default {
  actions
}
